import { render, staticRenderFns } from "./CompanyRequestButton.vue?vue&type=template&id=2bf226da"
import script from "./CompanyRequestButton.vue?vue&type=script&lang=js"
export * from "./CompanyRequestButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports